import { useMemo } from 'react';

import dynamic from 'next/dynamic';

import { usePortalState, PORTALS, ACTIONS } from '../PortalsProvider';

const PageAccessSwitcher = dynamic(() => import('components/Globals/Accounts/PageAccessSwitcher'));

const COMPONENTS_MAP = {
  [PORTALS.PAGE_ACCESS_SWITCHER]: PageAccessSwitcher,
};

const PortalsWrapper = () => {
  const { state, dispatch } = usePortalState();

  const openPortalTypes = useMemo(() => Object.keys(state).filter(type => state[type].open), [state]);

  if (openPortalTypes.length === 0) {
    return null;
  }

  return (
    <>
      {openPortalTypes.map(type => {
        const Component = COMPONENTS_MAP[type];

        if (!Component) {
          return null;
        }

        const { state: portalProps } = state[type] || {};

        return <Component key={type} {...portalProps} onClose={() => dispatch({ type, action: ACTIONS.HIDE })} />;
      })}
    </>
  );
};

export default PortalsWrapper;
